import useStore from 'stores/utils/hooks/useStore'

interface Props {
  height?: string
}

const GuenstigerGehtNicht = ({ height = '64px' }: Props) => {
  const clientDetails = useStore(
    (store) => store.clientDetailsStore?.clientDetails
  )

  return (
    <img
      src={clientDetails?.logos?.guenstigerGehtNicht}
      alt="Günstiger geht nicht Garantie"
      height={height}
      data-testid="guenstiger-geht-nicht-image"
    />
  )
}

export default GuenstigerGehtNicht
